import { z } from 'zod';

export const DtBulkItemSchema = z.object({
    entityId: z.string().describe("ID de l'entité"),
    entityType: z.enum(['candidate', 'resource']).describe("Type d'entité"),
    selectionOrder: z.number().describe('Ordre de sélection dans la liste'),
    label: z.string().nullish().describe('Label ou nom de la ligne'),
    selectedCvId: z.string().nullish().describe('ID du CV sélectionné pour la génération'),
    sources: z.array(z.string()).nullish().describe('Sources de données à utiliser'),
    fieldsToEnrich: z.array(z.string()).nullish().describe('Champs à enrichir pour cet élément'),
    referenceDtId: z.string().nullish().describe('DT de référence'),
    includeOpportunityContext: z.boolean().nullish().describe("Inclure le contexte de l'opportunité"),
});
export type DtBulkItemDto = z.infer<typeof DtBulkItemSchema>;

export const DtBulkExportItemSchema = DtBulkItemSchema.extend({
    selectedTemplate: z.string().nullish().describe('ID du template sélectionné pour l\'export'),
    exportBoondType: z.enum(['dt', 'fp', 'both']).nullish().describe("Type d'export vers BoondManager (DT, Fiche Profil, ou les deux)"),
    entitySheet: z.record(z.string(), z.unknown()).nullish().describe('Données de la fiche entité'),
});
export type DtBulkExportItemDto = z.infer<typeof DtBulkExportItemSchema>;

export const CreateDtBulkGenerationSchema = z.object({
    opportunityId: z.string().describe("ID de l'opportunité rattachée au traitement par lots"),
    items: z.array(DtBulkItemSchema).describe('Liste des éléments (candidats/ressources) à traiter'),
    sources: z.array(z.string()).describe('Sources de données globales (fallback)'),
    fieldsToEnrich: z.array(z.string()).describe('Champs globaux à enrichir'),
    generationMode: z.enum(['ai', 'cv', 'dt']).nullish().describe('Mode de génération globale'),
    documentType: z.enum(['dt-neylia', 'mini-cv']).nullish().describe('Format du document à générer'),
    referenceDtId: z.string().nullish(),
    actionsPeriod: z.number().nullish(),
    enrichEntitySheet: z.boolean().nullish(),
});
export type CreateDtBulkGenerationDto = z.infer<typeof CreateDtBulkGenerationSchema>;

export const CreateDtBulkDocumentExportSchema = z.object({
    opportunityTitle: z.string().nullish().describe("Titre de l'opportunite ciblee"),
    opportunityId: z.string().describe("ID de l'opportunité ciblée"),
    items: z.array(DtBulkItemSchema).describe('Liste des éléments à exporter'),
    exportType: z.enum(['word', 'pdf', 'book']).describe("Format d'export désiré"),
    selectedTemplate: z.string().nullish().describe('Template principal'),
    selectedBookTemplate: z.string().nullish().describe('Template de type Book (livret)'),
});
export type CreateDtBulkDocumentExportDto = z.infer<typeof CreateDtBulkDocumentExportSchema>;

export const CreateDtBulkBoondExportSchema = z.object({
    opportunityId: z.string().describe("ID de l'opportunité ciblée"),
    items: z.array(DtBulkItemSchema).describe('Liste des éléments à exporter vers BoondManager'),
    exportType: z.literal('boond').describe("Type d'export (toujours 'boond')"),
    exportBoondType: z.string().nullish().describe('Sous-type BoondManager (ex: dt, fp)'),
});
export type CreateDtBulkBoondExportDto = z.infer<typeof CreateDtBulkBoondExportSchema>;

export const CreateDtBulkExportSchema = z.object({
    opportunityTitle: z.string().nullish().describe("Titre de l'opportunite ciblee"),
    opportunityId: z.string().describe("ID de l'opportunité ciblée"),
    items: z.array(DtBulkExportItemSchema).describe('Configurations détaillées pour chaque ligne à exporter'),
    exportTypes: z.array(z.enum(['word', 'pdf', 'boond', 'book'])).describe('Liste des formats à générer en même temps'),
    selectedBookTemplate: z.string().nullish().describe('Template de compilation (Book)'),
});
export type CreateDtBulkExportDto = z.infer<typeof CreateDtBulkExportSchema>;
